import "./Projects.css";
import BUTOO from "./Images/BU-TOO.png";
import IMPORIUM from "./Images/Imporium.png";
import CRYPTONTW from "./Images/CRYPTO-NTW.png";
import DAILYNODE from "./Images/DAILYNODE.png";
import PORTFOLIO from "./Images/PORTFOLIO.png";
import TWTR from "./Images/TwitterSentiment.png";
import VolSurf from "./Images/VolSurf.png";
import PROMPTU from "./Images/promptu.png";

const PROJECTS_DATA = [
  {
    id: "crypto-network",
    title: "Bidirectional network of cryptocurrency exchange pairs",
    technologies: "Technologies: Python, NetworkX",
    image: CRYPTONTW,
    githubUrl:
      "https://github.com/andrewleenyk/Cryptocurrency-Exchange-Volume-Bidirectional-Network",
    alt: "Cryptocurrency network analysis project",
  },
  {
    id: "twitter-sentiment",
    title: "Twitter Sentiment Analysis",
    technologies: "Technologies: Python, Plotly, Pandas, Numpy, Tweepy",
    image: TWTR,
    githubUrl:
      "https://github.com/andrewleenyk/Twitter-API-Sentiment-Analysis-and-Data-Visuals",
    alt: "Twitter sentiment analysis project",
  },
  {
    id: "volatility-surface",
    title: "Option Volatility Surface",
    technologies: "Technologies: Python, Numpy, SciPy, Plotly",
    image: VolSurf,
    githubUrl: "https://github.com/andrewleenyk/Option-Volatility-Surface",
    alt: "Option volatility surface project",
  },
  {
    id: "nft-marketplace",
    title: "NFT Marketplace Full CRUD",
    technologies: "Technologies: React, Express, JS",
    image: IMPORIUM,
    githubUrl: "https://github.com/dayi2007/imporium",
    alt: "NFT marketplace project",
  },
  {
    id: "bu-too",
    title: "Anonymous Sexual Assault Story Forum",
    technologies: "Technologies: React, Airtable API, JS, Material UI",
    image: BUTOO,
    githubUrl: "https://github.com/andrewleenyk/-BUtoo",
    alt: "Anonymous forum project",
  },
  {
    id: "tech-blog",
    title: "Tech-themed Blog Full CRUD",
    technologies: "Technologies: React, Ruby, JS, PSQL",
    image: DAILYNODE,
    githubUrl: "https://github.com/andrewleenyk/WEB3-Blog",
    alt: "Tech blog project",
  },
  {
    id: "portfolio",
    title: "Portfolio Website",
    technologies: "Technologies: React, CSS, Adobe Illustrator",
    image: PORTFOLIO,
    githubUrl: "https://github.com/andrewleenyk/portfolio-site",
    alt: "Portfolio website project",
  },
  {
    id: "promptu",
    title: "promptu",
    technologies: "Technologies: React, Firebase, Chakra UI",
    image: PROMPTU,
    githubUrl: "https://github.com/serencha/promptu",
    alt: "Promptu project",
  },
];

function Projects() {
  return (
    <div className="Projects-main">
      <h2 className="proj-heading">PROJECTS</h2>
      <ul className="project-container">
        {PROJECTS_DATA.map((project) => (
          <li key={project.id} className="project-box">
            <h3 className="card-title">{project.title}</h3>
            <h2>{project.technologies}</h2>
            <a
              href={project.githubUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`View ${project.title} on GitHub`}
            >
              <img
                className="project-img"
                src={project.image}
                alt={project.alt}
              />
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Projects;
